/**
 * 拉取列表接口的全部数据（自动翻页）。
 * 后端 LimitedPagination 默认每页 16 条，且原先忽略 page_size，
 * 全量打印必须循环请求直到取完。
 *
 * @param {Function} listApi 返回 Promise，形如 (params) => Promise<{count, results}>
 * @param {Object} baseParams 除 page / page_size 外的查询参数
 * @param {number} pageSize 每页条数
 * @returns {Promise<Array>}
 */
export async function fetchAllPages(listApi, baseParams = {}, pageSize = 200) {
  const all = [];
  let page = 1;
  let total = Infinity;

  while (all.length < total) {
    const data = await listApi({
      ...baseParams,
      page,
      page_size: pageSize,
    });
    const results = data.results || [];
    total = typeof data.count === 'number' ? data.count : all.length + results.length;
    all.push(...results);
    if (!results.length) break;
    page += 1;
    // 防护：避免异常接口死循环
    if (page > 10000) break;
  }

  return all;
}
